import {
  DateRangeInput as BlueprintDateRangeInput,
  DateRange,
  TimePrecision,
} from '@blueprintjs/datetime';
import * as React from 'react';

import { isValidDate } from 'bones/utils/dates/isValidDate';
import { parseDatePickerInput } from 'bones/utils/dates/parseDatePickerInput';
import {
  formatDate,
  getXsdDateStringFromDate,
  getXsdDateTimeStringFromDate,
} from 'bones/utils/dates/xsdFormat';

export interface DateRangeInputProps {
  dateSplitSymbol: string;
  onSetValue: (value: string) => void;
  placeholder?: string;
  testId?: string;
  time?: boolean;
  value: string | null;
}

export const DateRangeInput: React.VFC<DateRangeInputProps> = ({
  dateSplitSymbol,
  onSetValue,
  placeholder,
  testId,
  time,
  value,
}) => {
  const dates: DateRange = value
    ? (value.split(dateSplitSymbol).map((dateString) => {
        const date = new Date(time ? dateString : `${dateString}T00:00:00`);
        return isValidDate(date) ? date : null;
      }) as DateRange)
    : [null, null];

  return (
    <div className="sd-input-date-range" data-testid={testId}>
      <BlueprintDateRangeInput
        formatDate={formatDate}
        maxDate={new Date('01/01/3000')}
        minDate={new Date('01/01/1000')}
        onChange={([firstDate, secondDate]) => {
          const firstDateString = firstDate
            ? (time ? getXsdDateTimeStringFromDate : getXsdDateStringFromDate)(
                firstDate
              )
            : '';
          const secondDateString = secondDate
            ? (time ? getXsdDateTimeStringFromDate : getXsdDateStringFromDate)(
                secondDate
              )
            : '';
          const joinedDates = `${firstDateString}${dateSplitSymbol}${secondDateString}`;
          onSetValue(joinedDates);
        }}
        parseDate={parseDatePickerInput}
        placeholder={placeholder}
        shortcuts={false}
        timePickerProps={
          time ? { showArrowButtons: true, useAmPm: true } : undefined
        }
        timePrecision={time ? TimePrecision.SECOND : undefined}
        value={dates}
      />
    </div>
  );
};
